import { render, staticRenderFns } from "./SalesTopRecordClass.vue?vue&type=template&id=9b8c6b0c"
import script from "./SalesTopRecordClass.vue?vue&type=script&lang=js"
export * from "./SalesTopRecordClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports